import React from 'react';
import ZapIcon from '@zapsa/zap-icons';

const NotFound = () => (
  <div className="container">
    <div className="notFound">
      <ZapIcon icon="notFound--lines" />
      <h2 className="notFound-headline">404 page not found</h2>
    </div>
  </div>
);

export default NotFound;
